export enum STORY_MODULES {
  DETAILS = 'details',
  RECOMMENDATIONS = 'recommendations',
  CREATOR = 'creator',
  PRICE = 'price',
  FUNNEL = 'funnel',
  AUDIO = 'audio',
}
